module.exports = __webpack_public_path__ + "img/kg_kg_04.444ced93.png";